export default "__VITE_ASSET__BfhKLp3J__"